module.exports = __webpack_public_path__ + "img/ic-hamburger.02fa8464.svg";